// extracted by mini-css-extract-plugin
export default {"raceSelector":"MultiLegTab_raceSelector__3fS7x","raceSelectorButton":"MultiLegTab_raceSelectorButton__PEFc7","btnChild":"MultiLegTab_btnChild__-1b8+"};